import { ContainerModule } from 'inversify'
import { TagServiceImpl } from './tag.service.impl'
import TYPES from '../../config/inversify.types'
import { TagStore } from '../../store/tag/tag.store'

export const TagModule = new ContainerModule((bind) => {
    bind(TYPES.TagService).to(TagServiceImpl).inSingletonScope()
    bind(TYPES.TagStore).to(TagStore).inSingletonScope()
})
